
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as blankUSA7GJSO2gPvkF_dcyhcIDG2tbWM06bk_M4TYbL090wMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/blank.vue?macro=true";
import { default as error9thvgUdzAeIl2OY2rndZJUDXcdOyC_gpKRw_45v8TIGYAMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/error.vue?macro=true";
import { default as indexMdByRjpgVLKHHdcsWrmRWb4nj6CfM3y4OS2Rl4mXEBUMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/index.vue?macro=true";
import { default as login74G5mK0sShze7UvLVG8QEqaH4nD_45VlJE_WptwMR6_45isMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/login.vue?macro=true";
import { default as logoutFRlGJJTSJ16OqSpNFJx49jNlhQ73is8nfjq_zyn1IsIMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/logout.vue?macro=true";
import { default as index6vypRTI9z_45zeADK00h6z51lszlFFCMxLRV2dy7Elj7QMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/index.vue?macro=true";
import { default as indexGXZFBYBSZw5Oz_tlvAuvPmYYyd9mzVkA6BK34HM_ueUMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/index.vue?macro=true";
import { default as leaderboardcTC58atn0XeZ47BW8g_45FE5HcSnMog0g3yYHdygUzkK0Meta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/leaderboard.vue?macro=true";
import { default as brandswEeizDk5FNLdF3u2_45ujz8nV8sgjuSsEN5MhjfyS2A4MMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/brands.vue?macro=true";
import { default as newlrZZa3LGk9zxSP0t40A_8Mp4KzpNAYklxRuanWPGnl8Meta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/new.vue?macro=true";
import { default as contactsth6tT6yzU1SN_lDS5CNr2BCy8xuSWCD3lAV6c1HKV8Meta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/contact.vue?macro=true";
import { default as expertsQ5Mjnhy_458vejdkOP_45peAYO64TtlClkNLgVKCl2ccCzcMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/experts.vue?macro=true";
import { default as indexx056SqDX1KWu5G0y4fG22viwcePGg4iI2Fe9I1Y__skMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/meetups/index.vue?macro=true";
import { default as indexszCHadTa5T9Si6pdSFF8SNEEAdZrIXPKXqjMxITEdagMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/profile/index.vue?macro=true";
import { default as creatorsWVlrun3i0d_45MTRdNLLx0DeZf098BbXuLJVGh2nMMaPoMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/creators.vue?macro=true";
import { default as indexOPNYG7j0zGNBzeDXVhMsuVDzs2AEYfTNfauYR8XjgCAMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/exercise/index.vue?macro=true";
import { default as indexoCYCQdALODqSSxox22E3ZlespH_45QQhAmFcyRH8J_45rAUMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/magazine/index.vue?macro=true";
import { default as index0yHPorXP5VjFWP5WCmTlcqoLXi306O8CBYxeQXEi8dgMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/password/index.vue?macro=true";
import { default as indexwcp40Ls_45oRUD72tXU8wmY5sKZClw_a99w9mJrU5MgxwMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/index.vue?macro=true";
import { default as indexu9f5LC8ErDTy6sP5_yMue2DySTJpq3SZB74CKM6KmQcMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/register/index.vue?macro=true";
import { default as mbgJmGJN1AGMIP5BVTjikOLPNA3yA6miicpm6zbU4wcNDsMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/mbg.vue?macro=true";
import { default as verifyOsF8qUVR6qn7B7CVrZOvcMS0geVjJ6OvT_45awsyZCmcYMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/password/verify.vue?macro=true";
import { default as zotrimIrt0smmvP5msOji3t05GMffydN1KoHUB2GjDJbASVBoMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/zotrim.vue?macro=true";
import { default as verifyzkwOKl7U3fPKvXHxA0szcQznwZYTCuhU5taXxF5G3tcMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/register/verify.vue?macro=true";
import { default as affiliatess5pdq5M55rPel5UWeC6ZMaWK2gs88VoQzvmJ5rk9ET8Meta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/affiliates.vue?macro=true";
import { default as index1WPm8pkasHa_CJ3dXIAITriWkAZoSgA5agcIJYZE3hYMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/challenges/index.vue?macro=true";
import { default as requestdmk8hTzpCTDlPm1XwSpW5veobxHBgW4LvXSoDHaXqeYMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/magazine/request.vue?macro=true";
import { default as indexhBIzGTfEX0GuWxLkIzTippIkW8rqn9dW_GGKOZ3_m_EMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/index.vue?macro=true";
import { default as indexIZLuu35EiF6Qlw_45Jp8AJqH0QY7IMzoyf_4556H1rd7TwoMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/users/index.vue?macro=true";
import { default as indexCUJTE8oHIw_5VlCN5yjTMrRZXo6NRD37ef69V5V_45xtsMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/discussions/index.vue?macro=true";
import { default as phengoldlBwc3En9BCHQ8Y06ASlDKVqP0ulkUJcq2Fgl_45Pt3RXoMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/phengold.vue?macro=true";
import { default as testogen9iJ9ijS_Vjd4fDBOkmNtil94HqZY_wgLKOlj7Zuk3JQMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/testogen.vue?macro=true";
import { default as trimtonenu_0QMC_45JC5j6k3YufzFB7egUPktY5I6ZRRHgqQFHF8Meta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/trimtone.vue?macro=true";
import { default as cancelNw_LAxDPtP8XB6o2lFZgy031z1mll42_g5zXX3B_hFEMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/cancel.vue?macro=true";
import { default as refundSE7U0jOjL499mNS5c0Lozkm_AgDpOwsmrTiqqDPE9D8Meta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/refund.vue?macro=true";
import { default as create___RbWVT7SwCIN9tfmvAzVuI5OOvn1H81IuWUtKnj6IMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/users/create.vue?macro=true";
import { default as blackwolfo6faICNIomBlVgfSkngdsEkCpsVd2E2vQ1Vk_45uUcBMMMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/blackwolf.vue?macro=true";
import { default as privacyk6_45JVkB3SDTDTxKVCP_cCo_45xO78I5M6tojfCQ5k6jIIMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/privacy.vue?macro=true";
import { default as indexuESEumkSrlTIHzI3cbAPMNaSXheLlp6abkqxmUsmjxYMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/reviews/index.vue?macro=true";
import { default as berbaprimeNV8iKjRHO4l0UjfXY8qzQ_1TFqUxLtL1VjYB0bkZsvgMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/berbaprime.vue?macro=true";
import { default as primeshred3uNakYE_45llxcVkXLMnuW_45mfEdh1EuKbdJrEMzUAj_45uwMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/primeshred.vue?macro=true";
import { default as shipping6RinSbdmBvEYMm9ftGc4QiyRsAsal7iIvBn7OVJOG5EMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/shipping.vue?macro=true";
import { default as createcxtjRwx1Mnbv03FdNZkIuXgMdHd18B5n7_4586PUSfqKgMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/reviews/create.vue?macro=true";
import { default as indexIAscCQngDsHhBAgYKvdcuMq4hQWnKaIhWCHGWVnDJ1MMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/redirects/index.vue?macro=true";
import { default as mindvitalityDcCyiZjP_HEyP3P9bgoHurKHC6STdTYu4_45pSyknJPTQMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/mindvitality.vue?macro=true";
import { default as notifications3vQakBwC1J_45aquDZNqf5pwMyCqDAv3P8bFTRgizCJukMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/profile/notifications.vue?macro=true";
import { default as createuH3Q1MxJ19wmylBtdTtrqIsKnN0zx7dvOI45PBCcd9sMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/redirects/create.vue?macro=true";
import { default as subscriptions_45faqI9QMTdBF3h0F13BO0xGo86EDEUBhjbLJp7kQzYG1q_45EMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/subscriptions-faq.vue?macro=true";
import { default as newta4vAiRLl_45zw0YSE7kvNDPNa3E9jYJ1ndLQ_45Lk_45k4dkMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/discussions/[forum]/new.vue?macro=true";
import { default as _91id_93pyxqNVotTiTlQQRLZLWiQrB7WJhUYNEA2WOEaFO8CmUMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/goto/[...resource]/[id].vue?macro=true";
import { default as indexzso3RxaYy582DZle6UhhuSSI7dk9U_RfMNS6of75Ya0Meta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/profile/[username]/index.vue?macro=true";
import { default as subscriptionsk9VIZLOZaT7NeuBUCBJJlUkotaiRjNLK2zE_JfVJpL4Meta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/subscriptions.vue?macro=true";
import { default as index6UIvBwB2wGzQsGJWVYYxHEiaudoobiIttlytIn8Z9O4Meta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/discussions/[forum]/index.vue?macro=true";
import { default as _91_46_46_46product_93Av6woBJr5t4bcT1CCCzhvbqmEvD1vK_45KPkCKhoWGnbsMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/buy/[...product].vue?macro=true";
import { default as index8xjVMC_4575Xhlb013yl6hNZ1hzrTwkXhkq34Yr3yhXTEMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/magazine/[...category]/index.vue?macro=true";
import { default as index9Fhf6vn2H_JegTyEOMI_gV7SbPZPOfQ3CIsijLmaTlUMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/[...category]/index.vue?macro=true";
import { default as index6qcExwuKS_mEn5_RO7YkRmhWZiUWm7Nq1rLgn4y3kmcMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/discussions/[forum]/[handle]/index.vue?macro=true";
import { default as _91article_93hyV5ES2jip_45RFDM2E_9EkFqznxEYMxZf137ZIFAHq8IMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/magazine/[...category]/article/[article].vue?macro=true";
import { default as indexIP4UCL5GARn2HQa7unAhtUQg7tKeRWuqPbTf3j7Pv4cMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/[...category]/product/[handle]/index.vue?macro=true";
import { default as reviewsND7txrLjJ4CuH118HMbkFx6q9SNsNkkZYiuvHVwvDkkMeta } from "/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/[...category]/product/[handle]/reviews.vue?macro=true";
export default [
  {
    name: "blank",
    path: "/blank",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/blank.vue")
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexMdByRjpgVLKHHdcsWrmRWb4nj6CfM3y4OS2Rl4mXEBUMeta || {},
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/logout.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/index.vue")
  },
  {
    name: "leaderboard",
    path: "/leaderboard",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/leaderboard.vue")
  },
  {
    name: "about-brands",
    path: "/about/brands",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/brands.vue")
  },
  {
    name: "products-new",
    path: "/products/new",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/new.vue")
  },
  {
    name: "about-contact",
    path: "/about/contact",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/contact.vue")
  },
  {
    name: "about-experts",
    path: "/about/experts",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/experts.vue")
  },
  {
    name: "meetups",
    path: "/meetups",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/meetups/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/profile/index.vue")
  },
  {
    name: "about-creators",
    path: "/about/creators",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/creators.vue")
  },
  {
    name: "exercise",
    path: "/exercise",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/exercise/index.vue")
  },
  {
    name: "magazine",
    path: "/magazine",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/magazine/index.vue")
  },
  {
    name: "password",
    path: "/password",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/password/index.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/index.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/register/index.vue")
  },
  {
    name: "about-terms-mbg",
    path: "/about/terms/mbg",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/mbg.vue")
  },
  {
    name: "password-verify",
    path: "/password/verify",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/password/verify.vue")
  },
  {
    name: "products-zotrim",
    path: "/products/zotrim",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/zotrim.vue")
  },
  {
    name: "register-verify",
    path: "/register/verify",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/register/verify.vue")
  },
  {
    name: "about-affiliates",
    path: "/about/affiliates",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/affiliates.vue")
  },
  {
    name: "challenges",
    path: "/challenges",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/challenges/index.vue")
  },
  {
    name: "magazine-request",
    path: "/magazine/request",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/magazine/request.vue")
  },
  {
    name: "about-terms",
    path: "/about/terms",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/users/index.vue")
  },
  {
    name: "discussions",
    path: "/discussions",
    meta: indexCUJTE8oHIw_5VlCN5yjTMrRZXo6NRD37ef69V5V_45xtsMeta || {},
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/discussions/index.vue")
  },
  {
    name: "products-phengold",
    path: "/products/phengold",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/phengold.vue")
  },
  {
    name: "products-testogen",
    path: "/products/testogen",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/testogen.vue")
  },
  {
    name: "products-trimtone",
    path: "/products/trimtone",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/trimtone.vue")
  },
  {
    name: "about-terms-cancel",
    path: "/about/terms/cancel",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/cancel.vue")
  },
  {
    name: "about-terms-refund",
    path: "/about/terms/refund",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/refund.vue")
  },
  {
    name: "admin-users-create",
    path: "/admin/users/create",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/users/create.vue")
  },
  {
    name: "products-blackwolf",
    path: "/products/blackwolf",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/blackwolf.vue")
  },
  {
    name: "about-terms-privacy",
    path: "/about/terms/privacy",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/privacy.vue")
  },
  {
    name: "admin-reviews",
    path: "/admin/reviews",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/reviews/index.vue")
  },
  {
    name: "products-berbaprime",
    path: "/products/berbaprime",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/berbaprime.vue")
  },
  {
    name: "products-primeshred",
    path: "/products/primeshred",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/primeshred.vue")
  },
  {
    name: "about-terms-shipping",
    path: "/about/terms/shipping",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/shipping.vue")
  },
  {
    name: "admin-reviews-create",
    path: "/admin/reviews/create",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/reviews/create.vue")
  },
  {
    name: "admin-redirects",
    path: "/admin/redirects",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/redirects/index.vue")
  },
  {
    name: "products-mindvitality",
    path: "/products/mindvitality",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/mindvitality.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/profile/notifications.vue")
  },
  {
    name: "admin-redirects-create",
    path: "/admin/redirects/create",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/admin/redirects/create.vue")
  },
  {
    name: "about-subscriptions-faq",
    path: "/about/subscriptions-faq",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/subscriptions-faq.vue")
  },
  {
    name: "discussions-forum-new",
    path: "/discussions/:forum()/new",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/discussions/[forum]/new.vue")
  },
  {
    name: "goto-resource-id",
    path: "/goto/:resource([^/]*)*/:id()",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/goto/[...resource]/[id].vue")
  },
  {
    name: "profile-username",
    path: "/profile/:username()",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/profile/[username]/index.vue")
  },
  {
    name: "about-terms-subscriptions",
    path: "/about/terms/subscriptions",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/about/terms/subscriptions.vue")
  },
  {
    name: "discussions-forum",
    path: "/discussions/:forum()",
    meta: index6UIvBwB2wGzQsGJWVYYxHEiaudoobiIttlytIn8Z9O4Meta || {},
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/discussions/[forum]/index.vue")
  },
  {
    name: "products-buy-product",
    path: "/products/buy/:product(.*)*",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/buy/[...product].vue")
  },
  {
    name: "magazine-category",
    path: "/magazine/:category(.*)*",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/magazine/[...category]/index.vue")
  },
  {
    name: "products-category",
    path: "/products/:category(.*)*",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/[...category]/index.vue")
  },
  {
    name: "discussions-forum-handle",
    path: "/discussions/:forum()/:handle()",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/discussions/[forum]/[handle]/index.vue")
  },
  {
    name: "magazine-category-article-article",
    path: "/magazine/:category([^/]*)*/article/:article()",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/magazine/[...category]/article/[article].vue")
  },
  {
    name: "products-category-product-handle",
    path: "/products/:category([^/]*)*/product/:handle()",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/[...category]/product/[handle]/index.vue")
  },
  {
    name: "products-category-product-handle-reviews",
    path: "/products/:category([^/]*)*/product/:handle()/reviews",
    component: () => import("/codebuild/output/src2408966383/src/client-healthnutrition/www/pages/products/[...category]/product/[handle]/reviews.vue")
  }
]